import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { AuthByUsernameSchema } from '../types/AuthByUsernameSchema'
import { loginByUsername } from '../services'

const initialState: AuthByUsernameSchema = {}

export const AuthByUsernameSlice = createSlice({
    name: 'AuthByUsername',
    initialState,
    reducers: {
        setUsername: (state, action: PayloadAction<string>) => {
            state.username = action.payload
        },
        setPassword: (state, action: PayloadAction<string>) => {
            state.password = action.payload
        },
        resetError: (state) => {
            state.error = undefined
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(loginByUsername.pending, (state) => {
                state.error = undefined
                state.isLoading = true
            })
            .addCase(loginByUsername.fulfilled, (state) => {
                state.isLoading = false
            })
            .addCase(loginByUsername.rejected, (state, action) => {
                state.isLoading = false
                state.error = action.payload
            })
    }
})

export const { actions: AuthByUsernameActions } = AuthByUsernameSlice
export const { reducer: AuthByUsernameReducer } = AuthByUsernameSlice
